import type { GameMeta } from '@gmp/game-sdk';

export const mercenaryMarketMeta = {
  id: 'mercenary-market',
  name: 'Mercenary Market',
  tagline: 'Draft three fighters, outbid your rival, watch them brawl.',
  description:
    'Each round you both draft three fighters from one shared market with 10 coins. Tank beats Rogue, Rogue beats Archer, Archer beats Tank. Want the same fighter? The higher secret bid gets it, the other gets a Recruit. Then the squads fight on their own. Best of three. Play a friend or a bot.',
  minPlayers: 2,
  maxPlayers: 2,
  estimatedMinutes: [5, 9],
  usesMedia: false,
  modes: [{ id: 'duel', name: 'Duel', description: 'Two players (or you and a bot), up to three fights.' }],
  theme: { primary: '#f2b134', secondary: '#4cc9f0', background: '#1b1407', ink: '#fff6e0' },
  readiness: 'beta',
  genre: 'Draft and auto-battle',
  controls: 'tap',
  category: 'versus',
  instructions: [
    { icon: 'Hand', title: 'Pick a fighter', body: 'Three picks a round from a shared market. You both see each other\'s squad and coins.' },
    { icon: 'Sparkles', title: 'Tank > Rogue > Archer > Tank', body: 'A fighter hits the role it beats for double damage. Two of a role or one of each gives a bonus.' },
    { icon: 'Vote', title: 'Same pick? Bid war', body: 'Bids are secret. Higher bid gets the fighter and pays; the other pays nothing and gets a Recruit. A tie: both get Recruits.' },
    { icon: 'Trophy', title: 'Best of three', body: 'Squads fight on their own. Coins reset every round; the loser of a fight gets +3 next round.' },
  ],
} satisfies GameMeta;
